import { Controller } from '@hotwired/stimulus'

// Collapsible suggested-options tray above the chat input. e.g "Flag my Server"
export default class extends Controller {
  static targets = ['caret', 'chips']
  static values = { collapsed: Boolean }
  static outlets = ['public-conversation']

  toggle() {
    this.collapsedValue = !this.collapsedValue
    this.element.toggleAttribute('data-collapsed', this.collapsedValue)
  }

  prefill(event) {
    if (!this.hasPublicConversationOutlet) return

    const input = this.publicConversationOutlet.inputTarget
    input.value = event.params.prefill
    input.focus()
    input.setSelectionRange(input.value.length, input.value.length)
  }
}
